/*
 * This file is part of AdBlock  <https://getadblock.com/>,
 * Copyright (C) 2013-present  Adblock, Inc.
 *
 * AdBlock is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License version 3 as
 * published by the Free Software Foundation.
 *
 * AdBlock is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with AdBlock.  If not, see <http://www.gnu.org/licenses/>.
 */

export const imageSizesMap = new Map([
  ["NONE", 0],
  ["wide", 1],
  ["tall", 2],
  ["skinnywide", 4],
  ["skinnytall", 8],
  ["big", 16],
  ["small", 32],
]);

export const WIDE = imageSizesMap.get("wide");
export const TALL = imageSizesMap.get("tall");
export const BIG = imageSizesMap.get("big");
export const SMALL = imageSizesMap.get("small");
export const SKINNYWIDE = imageSizesMap.get("skinnywide");
export const SKINNYTALL = imageSizesMap.get("skinnytall");
